/**
 * @file Reads whether analytics is configured for the organisation: both
 * `parameters/analytics` and `parameters/analyticsBindings` exist. Consumers:
 * the Analytics page, Home's tiles and Needs me, and the Reports
 * panel. Both documents are read through `useStoreDocsByPaths`, so the
 * listeners share the refcounted registry. `configured` is false while either
 * document is loading, absent or deleted; `loading` is true until both first
 * snapshots arrive (or fail), so a surface can wait rather than flash the
 * not-configured state.
 */
import { ANALYTICS_BINDINGS_PATH, ANALYTICS_PARAMETERS_PATH } from '#types';
import { useStoreDocsByPaths } from '@/store';

const CONFIGURATION_PATHS = [
  ANALYTICS_PARAMETERS_PATH,
  ANALYTICS_BINDINGS_PATH,
];

export const useAnalyticsConfigured = (): {
  configured: boolean;
  loading: boolean;
} => {
  const { data, loading } = useStoreDocsByPaths(CONFIGURATION_PATHS);
  return {
    configured:
      data.has(ANALYTICS_PARAMETERS_PATH) && data.has(ANALYTICS_BINDINGS_PATH),
    loading,
  };
};
